import { render, staticRenderFns } from "./bwggk.vue?vue&type=template&id=1f4e062d&scoped=true&"
import script from "./bwggk.vue?vue&type=script&lang=js&"
export * from "./bwggk.vue?vue&type=script&lang=js&"
import style0 from "./bwggk.vue?vue&type=style&index=0&id=1f4e062d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e062d",
  null
  
)

export default component.exports